import React from "react";
import "../../pages/style.css";
import Typewriter from "typewriter-effect";

const Text = () => {
  return (
    <Typewriter
      options={{
        strings: ["React Js Developer", "FrontEnd Web Developer"],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
};

export default Text;
